import Axios from 'axios'

// constant
import * as types from '../types'
import { host } from '../../../../host'

// helper
import catchErrorApi from '../../../../helper/catchErrorApi'
import autoDownloadFromBlob from '../../../../helper/autoDownloadFromBlob'

// action
import { addLoading, removeLoading } from '../../../commonAction'

const apiGetListSelfServeByOfficeAndTrans = `${host}admin/exportJSON/selfServeReport`

export const getListSelfServeByOfficeAndTrans = ({
    FromDate,
    ToDate,
    BranchIDs,
    ServiceCode,
    ReportCodeName,
    BranchName,
}) => async (dispatch) => {
    dispatch(addLoading())
    const dataRequest = JSON.stringify({
        FromDate,
        ToDate,
        BranchIDs,
        ServiceCode,
        ReportCodeName,
        BranchName,
    })

    try {
        const res = await Axios.post(
            apiGetListSelfServeByOfficeAndTrans,
            dataRequest
        )
        const { data } = res
        dispatch({
            type: types.GET_LIST_SELF_SERVE_BY_OFFICES_AND_TRANS,
            payload: {
                condFilter: {
                    FromDate,
                    ToDate,
                    BranchIDs,
                    ServiceCode,
                    ReportCodeName,
                    BranchName,
                },
                listData: data.Data || [],
            },
        })
        dispatch(removeLoading())
    } catch (err) {
        dispatch(removeLoading())
        catchErrorApi(
            err,
            dispatch,
            types.GET_LIST_SELF_SERVE_BY_OFFICES_AND_TRANS_ERROR,
            () => false
        )
    }
}

export const exportListSelfServeByOfficeAndTrans = ({
    FromDate,
    ToDate,
    BranchIDs,
    ServiceCode,
    ReportCodeName,
    BranchName,
    BranchCodes,
}) => async (dispatch) => {
    if (!BranchCodes) return

    dispatch(addLoading())
    const dataRequest = JSON.stringify({
        FromDate,
        ToDate,
        BranchIDs,
        ServiceCode,
        ExportExcel: true,
        ReportCodeName,
        BranchName,
    })

    try {
        const res = await Axios.post(
            apiGetListSelfServeByOfficeAndTrans,
            dataRequest,
            {
                responseType: 'blob',
            }
        )
        dispatch(removeLoading())
        const { data } = res
        if (BranchCodes.length === 1) {
            autoDownloadFromBlob(data, `${ReportCodeName}-${BranchCodes[0]}`)
        } else {
            autoDownloadFromBlob(
                data,
                `${ReportCodeName}-${BranchCodes.join('-')}`
            )
        }
    } catch (err) {
        dispatch(removeLoading())
        console.log(err)
    }
}
